import { render, staticRenderFns } from "./QTemplateCreate.vue?vue&type=template&id=1da63c6f&"
import script from "./QTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./QTemplateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports